import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentHistoryRoutingModule } from './payment-history-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TableComponent } from './table/table.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [TableComponent],
  imports: [CommonModule, PaymentHistoryRoutingModule, SharedModule],
  exports: [TableComponent],
})
export class PaymentHistoryModule {}
